export const PAGE_HEIGHT = 940;
export const HEADER_HEIGHT = 70;
export const FOOTER_HEIGHT = 5;
export const ROW_HEIGHT = 55;

export const getRowsPerPage = () => {
  const availableHeight = PAGE_HEIGHT - HEADER_HEIGHT- FOOTER_HEIGHT;
  return Math.floor(availableHeight / ROW_HEIGHT);
};

export const paginate = (data) => {
  const rowsPerPage = getRowsPerPage();
  const pages = [];
  for (let i = 0; i < data.length; i += rowsPerPage) {
    var insdata=data.slice(i, i + rowsPerPage);
      
    if(i===data.length-insdata.length)
   {
   
 if(insdata.length>10)
    {
       
    pages.push(insdata);
      pages.push([]);
    }
    else{
         
   pages.push(insdata);
    }
   }
   else{
     
     pages.push(insdata);
   }
   
 
  }
  return pages;
};

export const formatDate = (dateString) => {
 // const date = new Date(dateString);
 var cleanDate = dateString.replace("T00:00:00.000", "");
 cleanDate = cleanDate.replace("T00:00:00", "");
   const date = new Date(`${cleanDate}T00:00:00`);

  return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
};

export const formatDateForprintDate = (dateString) => {
 
   const date = new Date(dateString);

  return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
};

export const formatInstructorName=(name)=> {
  return name
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}


export const formattedStartAndEndDate = (date) => formatDate(date);

export const formattedDate = formatDateForprintDate(new Date().toLocaleDateString('en-US'));
